export enum AlertSeverity {
  LOW = 'LOW',
  INTERMEDIATE = 'INTERMEDIATE',
  CRITICAL = 'CRITICAL',
}